/*
  Sable — horizontal product tabs (ELAN style).
  Progressive enhancement: turns Dawn's collapsible_tab accordions in the
  product info column into a horizontal tab group (DETAILS / COMPOSITION /
  MEASUREMENTS across a row, one panel below). Without JS the blocks stay
  as native <details> accordions, so nothing is lost. Does not touch the
  product form or cart.
*/
(function () {
  'use strict';

  function enhance(info) {
    if (!info || info.dataset.sableTabs === '1') return;

    var accordions = Array.prototype.filter.call(
      info.querySelectorAll('.product__accordion'),
      function (el) {
        return el.querySelector('details') && el.querySelector('.accordion__content');
      }
    );
    if (accordions.length < 1) return;

    info.dataset.sableTabs = '1';

    var group = document.createElement('div');
    group.className = 'sable-tabs';
    var nav = document.createElement('div');
    nav.className = 'sable-tabs__nav';
    nav.setAttribute('role', 'tablist');

    accordions[0].parentNode.insertBefore(group, accordions[0]);
    group.appendChild(nav);

    var tabs = [];

    accordions.forEach(function (acc, i) {
      var details = acc.querySelector('details');
      var titleEl = acc.querySelector('.accordion__title');
      var content = acc.querySelector('.accordion__content');
      var label = (titleEl ? titleEl.textContent : 'Tab ' + (i + 1)).trim();

      group.appendChild(acc);
      acc.classList.add('sable-tabs__section');

      var tabId = 'SableTab-' + i + '-' + (details.id || i);
      var panelId = content.id || 'SablePanel-' + i;
      content.id = panelId;
      content.setAttribute('role', 'tabpanel');
      content.setAttribute('aria-labelledby', tabId);
      content.setAttribute('tabindex', '0');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sable-tabs__tab';
      btn.id = tabId;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-controls', panelId);
      btn.textContent = label;
      nav.appendChild(btn);

      var idx = i;
      btn.addEventListener('click', function () { activate(idx, true); });
      btn.addEventListener('keydown', function (e) { onKey(e, idx); });

      tabs.push({ btn: btn, details: details, content: content, section: acc });
    });

    function activate(idx, focus) {
      tabs.forEach(function (t, i) {
        var on = i === idx;
        t.details.open = on;
        t.btn.setAttribute('aria-selected', on ? 'true' : 'false');
        t.btn.setAttribute('tabindex', on ? '0' : '-1');
      });
      if (focus) tabs[idx].btn.focus();
    }

    function onKey(e, idx) {
      var next = null;
      var last = tabs.length - 1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = idx === last ? 0 : idx + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = idx === 0 ? last : idx - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = last;
      if (next !== null) { e.preventDefault(); activate(next, true); }
    }

    group.classList.add('sable-tabs--ready');
    activate(0, false);

    // Theme editor: open the tab a merchant selects.
    group._sableActivateFor = function (el) {
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].section.contains(el)) { activate(i, false); return; }
      }
    };
  }

  function run(root) {
    (root || document).querySelectorAll('.product__info-container').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  // Re-enhance when the theme editor reloads the product section.
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var group = e.target.closest('.product__info-container');
    if (!group) return;
    var tabsEl = group.querySelector('.sable-tabs');
    if (tabsEl && tabsEl._sableActivateFor) tabsEl._sableActivateFor(e.target);
  });
})();
